module.exports = __webpack_public_path__ + "files/black.4e9673fff18de90c8cbda67a33c5007b.png";